// extracted by mini-css-extract-plugin
export default {"sidebar_item":"SidebarItem_sidebar_item__rr8el"};